module.exports = __webpack_public_path__ + "img/01-T.2f306bfa.png";